// components/ConsentAwareEmbed/ConsentAwareEmbed.tsx
import React from "react";
import { useCookieContext } from "../../context/CookieContext";

interface ConsentAwareEmbedProps {
  type: "youtube" | "google-maps" | "analytics" | "marketing";
  children: React.ReactNode;
  placeholder?: React.ReactNode;
}

const ConsentAwareEmbed: React.FC<ConsentAwareEmbedProps> = ({
  type,
  children,
  placeholder,
}) => {
  const { cookieSettings, openBanner } = useCookieContext();

  const isAllowed = () => {
    switch (type) {
      case "youtube":
      case "google-maps":
      case "marketing":
        return cookieSettings.marketing;
      case "analytics":
        return cookieSettings.analytics;
      default:
        return false;
    }
  };

  if (!isAllowed()) {
    return (
      placeholder || (
        <div className="consent-placeholder">
          <p>
            Um diesen Inhalt anzusehen, erlauben Sie bitte {type}-Cookies in den
            Einstellungen.
          </p>
          <button className="consent-placeholder__button" onClick={openBanner}>
            Cookies-Einstellungen öffnen
          </button>
        </div>
      )
    );
  }

  return <>{children}</>;
};

export default ConsentAwareEmbed;
